<template>
  <div>
    <b-row class="d-flex justify-content-between align-items-center">
      <div class="col">
        <strong style="font-size: 150%">Equipo Trabajo</strong>
      </div>
      <div class="col-auto">
        <button
          v-if="showExportButton"
          @click="exportarExcel"
          class="btn btn-primary"
        >
          Exportar Excel
        </button>
      </div>
    </b-row>

    <b-row class="mt-5 mb-3">
  <b-col cols="11">
    <b-row class="mt-2 mb-4" style="padding-top: 30px">
      <b-col cols="2">
        <label>Consultor</label>
      </b-col>
      <b-col cols="8">
        <b-form-select v-model="consultorNombre" size="sm">
          <option v-for="co in consultoresOrdenados" :value="co" :key="co.id">
            {{ co.nombre }} {{ co.externo ? '- Externo' : '' }}
          </option>
        </b-form-select>
      </b-col>
    </b-row>
  </b-col>

  <b-col cols="1" style="padding: 29px 0px 0px 0px">
    <b-button
      :disabled="
        !['ROLE_SUPERADMIN', 'ROLE_TRAINING', 'ROLE_SALES','ROLE_MANAGER'].includes(
          currentUser.roles[0]
        )
      "
      variant="success"
      class="actionButton"
      @click="addLineConsultor"
    >+</b-button>
  </b-col>
</b-row>


    <b-row>
      <b-col>
        <b-table
          style="font-size: 90%"
          class="shadow-sm vertical-center mt-4 text-center"
          responsive
          id="equipoLocal"
          :fields="tableFields"
          :items="equipoLocal"
          bordered
          hover
          small
        >
        

          <template #cell(categoriaPHA)="row" text-center>
            <td class="d-flex justify-content-center align-items-center">
              <b-form-select
                v-model="row.item.categoriaPHA"
                size="sm"
                @change="emitUpdate"
                :disabled="currentUser.roles[0] == 'ROLE_USER' || currentUser.roles[0] == 'ROLE_SUPERUSER'"
              >
                <option :value="null">-- Seleccionar --</option>
                <option value="Chairman">Chairman</option>
                <option value="Scribe">Scribe</option>
              </b-form-select>
            </td>
          </template>

          <template #cell(facturacionConsultorPorcentaje)="row" text-center>
            <td class="d-flex justify-content-center align-items-center" style="background: rgb(228, 245, 229)">
              <b-form-input
                style="background: rgb(228, 245, 229); text-align: center"
                @change="updatefacturacionConsultorPorcentaje(row.item)"
                :disabled="(currentUser.roles[0] == 'ROLE_USER' || currentUser.roles[0] == 'ROLE_SUPERUSER') && showExportButton"
                v-model="row.item.facturacionConsultorPorcentaje"
                id="facturacionConsultorPorcentaje"
              />
            </td>
          </template>

          <template #cell(horasEstimadas)="row" text-center>
            <td class="d-flex justify-content-center align-items-center">
              <b-form-input
                @keydown.enter.prevent.stop
                :disabled="currentUser.roles[0] == 'ROLE_USER' || currentUser.roles[0] == 'ROLE_SUPERUSER'"
                style="text-align: center"
                @change="onHorasEstimadasChange"
                v-model="row.item.horasEstimadas"
                id="horasEstimadas"
              />
            </td>
          </template>

          <template #cell(action)="row">
            <td class="d-flex justify-content-center">
              <b-button
                :disabled="currentUser.roles[0] == 'ROLE_USER' || currentUser.roles[0] == 'ROLE_SUPERUSER'"
                size="sm"
                class="actionButton"
                variant="outline-danger"
                @click="deleteLineConsultor(row)"
              ><i class="fas fa-trash-alt"></i></b-button>
            </td>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-row v-if="openTraining==false" style="padding-top: 50px">
      <b-col cols="4">
        <label for="horasTotalesEstimadas1">Horas Totales Estimadas</label>
        <b-form-input
          class="form-control"
          size="sm"
          v-model="horasTotalesEstimadas1"
          id="horasTotalesEstimadas1"
          rows="1"
        ></b-form-input>
      </b-col>

      <b-col cols="4">
        <label for="horasTotalesRealizadas">Horas Totales Realizadas</label>
        <b-form-input
          class="form-control"
          size="sm"
          v-model="horasTotalesRealizadas"
          id="horasTotalesRealizadas"
          rows="1"
          @change="desviacion"
        ></b-form-input>
      </b-col>

      <b-modal ref="errorModal" title="Error al eliminar trabajador" hide-footer>
        <p>No se puede eliminar el trabajador porque tiene horas imputadas.</p>
      </b-modal>

      <b-col cols="4">
        <label for="desviacionHorasItem">Desviacion Item</label>
        <b-form-input
          class="form-control"
          size="sm"
          v-model="desviacionHorasItem"
          id="desviacionHorasItem"
          rows="1"
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row v-if="openTraining==false">
      <b-col cols="3" class="mt-5">
        <label for="avanceReal">Avance Según Horas (%)</label>
      </b-col>
      <b-col
        cols="2"
        class="mt-5 text-center d-flex align-items-center justify-content-center"
      >
        <b-form-input
          class="form-control font-weight-bold"
          size="sm"
          v-model="avanceReal"
          id="avanceReal"
          disabled
        ></b-form-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";

export default {
  name: "EquipoTrabajo",
  props: {
    consultoresProyecto: { type: Array, required: true },
    consultoriaHoras: { type: Boolean, required: true },
    numeroOferta: { type: String, required: true },
    numeroItem: { type: String, required: false, default: "0" },
    openTraining: { type: Boolean, required: true, default: false },
    tipoProyecto: { type: String, required: false, default: "" },
    // 🔗 prop sincronizada desde el padre (Item.vue la pasa como :equipo-trabajo="equipoTrabajo")
    equipoTrabajo: { type: Array, required: false, default: () => [] },
  },
  data() {
    return {
      consultorNombre: null,
      horasRealesConsultor: 0,
      horasRealesEquipoTrabajo: 0,
      desviacionHoras: 0,
      horasEstimadas: 0,

      // Estado interno editable
      equipoLocal: [],

      avanceReal1: 0,
      event: "",
      target: "",
      stopDate: "",
      usersSelected: [],
      users: [],
      
      horasTotalesEstimadas1: 0,
      horasTotalesEstimadas: 0,
      horasTotalesRealizadas: 0,
      desviacionHorasItem: 0,
      estimadasTotal: 0,
      facturacionConsultorPorcentaje: 0,
      details: [],
      itemList: [],
      costeHora: 0,
    };
  },
  watch: {
    // ← copia prop ➜ estado interno (inicial y en cambios desde el padre)
    equipoTrabajo: {
      handler(newVal) {
        this.equipoLocal = Array.isArray(newVal) ? [...newVal] : [];
        // Recalcula métricas cuando cambie desde fuera
        this.recalcular();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentRole() {
      return this.currentUser?.roles?.length ? this.currentUser.roles[0] : "";
    },
    todoFacturarMix() {
      if (this.consultoriaHoras) return true;
      const totalPorcentaje = this.equipoLocal.reduce(
        (total, c) => total + parseFloat(c.facturacionConsultorPorcentaje || 0),
        0
      );
      return totalPorcentaje === 100;
    },
    tableFields() {
      const fields = [
       
        { key: "consultorNombre.nombre", label: "Nombre",  thStyle: { width: "260px", textAlign: "center" }, tdStyle: { verticalAlign: "middle" } },
        { key: "horasEstimadas", label: "Horas Estimadas",  thStyle: { width: "80px", textAlign: "center" }, tdStyle: { verticalAlign: "middle" } },
        { key: "horasRealesConsultor", label: "Horas Reales",  thStyle: { width: "80px", textAlign: "center" }, tdStyle: { verticalAlign: "middle" } },
        { key: "facturacionConsultorPorcentaje", label: this.consultoriaHoras ? "Coste" : "Facturacion Consultor %",  thStyle: { width: "80px", textAlign: "center" }, tdStyle: { verticalAlign: "middle" } },
        { key: "action", label: "", thStyle: { width: "30px" }, tdStyle: { verticalAlign: "middle" } },
      ];
      if (!this.consultoriaHoras) {
        fields.splice(3, 0, {
          key: "desviacionHoras",
          label: "Desviación Horas",
          sortable: true,
          thStyle: { width: "80px", textAlign: "center" },
          tdStyle: { verticalAlign: "middle" },
        });
      }
      if (this.tipoProyecto === "PHA") {
        fields.splice(1, 0, {
          key: "categoriaPHA",
          label: "Categoria PHA",
          sortable: true,
          thStyle: { width: "120px", textAlign: "center" },
          tdStyle: { verticalAlign: "middle" },
        });
      }
      return fields;
    },
    consultoresOrdenados() {
      const empleadosFiltrados = this.consultoresProyecto.filter(
        (empleado) => empleado.idioma === "ESP" && empleado.estado
      );
      return empleadosFiltrados.sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    avanceReal() {
      if (this.horasTotalesEstimadas1 > 0) {
        const porcentaje = (this.horasTotalesRealizadas / this.horasTotalesEstimadas1) * 100;
        return porcentaje.toFixed(2);
      }
      return 0;
    },
    showExportButton() {
      return this.consultoriaHoras;
    },
  },
  methods: {
    // ===== Exportación =====
    exportarExcel() {
      api1
        .get(`/api/dekra-projects/v204/imputacionHorasExcel`, {
          params: {
            numeroOferta: this.numeroOferta,
            numeroItem: this.numeroItem,
          },
        })
        .then((response) => {
          this.itemList = response.data || [];
          if (!Array.isArray(this.itemList)) return;

          this.details = this.itemList
            .map((item) => {
              if (item.imputacionHoras && item.imputacionHoras.nombreConsultor) {
                return {
                  categoria: item.categoriaConsultor,
                  empleado: item.imputacionHoras.nombreConsultor.nombre,
                  fechaImputacionHoras: item.imputacionHoras.fechaImputacionHoras,
                  cliente: item.imputacionHoras.cliente,
                  numeroOferta: item.imputacionHoras.numeroOferta,
                  nombreOferta: item.imputacionHoras.nombreOferta,
                  numeroItem: item.imputacionHoras.numeroItem,
                  comentarios: item.imputacionHoras.comentarioHoras,
                  numeroHoras: item.imputacionHoras.numeroHoras,
                  importeHoras: item.costeHora * item.imputacionHoras.numeroHoras,
                  costeHoras: item.costeHora,
                  descripcion: item.descripcion,
                };
              }
              return null;
            })
            .filter(Boolean);

          this.exportarExcelJasper();
        })
        .catch((error) => {
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
          } else {
            this.showMsgBoxConfirm(
              error.response?.data?.message + " - Debug: " + error.response?.data?.debugMessage,
              "danger",
              "Error"
            );
          }
        });
    },

    exportarExcelJasper() {
      const tipo = "xlsx";
      const date = this.getFormatDate();

      return new Promise((resolve) => this.$nextTick(resolve)).then(() => {
        api1
          .post(
            `/api/reporting/v204/jasper/report/${tipo}`,
            {
              report: "/srv/dekra/report/excelHoras.jrxml",
              name: "ConsultoriaHorasImp",
              parameters: {},
              details: this.details,
            },
            { responseType: "blob" }
          )
          .then((response) => {
            const blob = new Blob([response.data], { type: response.headers["content-type"] });
            const fileDownload = require("js-file-download");
            fileDownload(blob, "HorasImputadas" + "_" + date + "." + tipo);
            this.busy = false;
          })
          .catch((error) => {
            this.showMsgBoxConfirm(
              error.response?.data?.message + " - Debug: " + error.response?.data?.debugMessage,
              "danger",
              "Error"
            );
            if (error.response?.status === 401 || error.response?.status === 403) {
              this.$store.dispatch("auth/logout");
              this.$router.push("/login");
            }
          });

        this.details = [];
      });
    },

    getFormatDate() {
      const date = new Date();
      return date.toLocaleDateString().replaceAll("/", "-");
    },

    // ===== Cálculos y sincronización =====
    recalcular() {
      this.calcularSumaHorasEstimadas();
      this.actualizarHorasTotalesRealizadas();
      this.actualizarDesviacion();
    },
    calcularSumaHorasEstimadas() {
      this.horasTotalesEstimadas1 = this.equipoLocal.reduce(
        (total, c) => total + parseFloat(c.horasEstimadas || 0),
        0
      );
    },
    actualizarHorasTotalesRealizadas() {
      this.horasTotalesRealizadas = this.equipoLocal.reduce(
        (total, c) => total + parseFloat(c.horasRealesConsultor || 0),
        0
      );
      this.desviacion();
    },
    actualizarDesviacion() {
      this.equipoLocal.forEach((c) => {
        c.desviacionHoras = (
          parseFloat(c.horasEstimadas || 0) - parseFloat(c.horasRealesConsultor || 0)
        ).toFixed(1);
      });
    },
   updateHorasTotalesEstimadas() {
  this.estimadasTotal = this.equipoLocal.reduce(
    (total, c) => total + parseFloat(c.horasEstimadas || 0),
    0
  );

  for (let i = 0; i < this.equipoLocal.length; i++) {
    this.equipoLocal[i].horasTotalesEstimadas = this.estimadasTotal;
  }

  this.calcularSumaHorasEstimadas();
  this.actualizarDesviacion();
},

    desviacion() {
      this.desviacionHorasItem = (
        parseFloat(this.horasTotalesEstimadas1 || 0) -
        parseFloat(this.horasTotalesRealizadas || 0)
      ).toFixed(1);
    },

    // ===== Mutadores (emiten al padre) =====
  addLineConsultor() {
  if (!this.consultorNombre) return;

  this.updateHorasTotalesEstimadas();
  const date = new Date();

  this.equipoLocal.push({
    consultorNombre: this.consultorNombre,
    horasEstimadas: this.horasEstimadas,
    horasTotalesEstimadas: this.estimadasTotal,
    desviacionHoras: this.desviacionHoras,
    horasRealesConsultor: parseFloat(this.horasRealesConsultor || 0),
    horasRealesEquipoTrabajo: this.horasRealesEquipoTrabajo,
    facturacionConsultorPorcentaje: this.facturacionConsultorPorcentaje,
    fechaImputacionPorcentaje: date,
    horasTotalesRealizadas: this.horasTotalesRealizadas,
    categoriaPHA: null,
  });

  this.recalcular();
  this.emitUpdate();

  this.consultorNombre = null;
  this.horasEstimadas = 0;
  this.estimadasTotal = 0;
},



    deleteLineConsultor(row) {
  if (parseFloat(row.item.horasRealesConsultor || 0) > 0) {
    this.$refs.errorModal?.show?.();
    return;
  }

  // Eliminar por índice de la fila
  this.equipoLocal.splice(row.index, 1);

  this.recalcular();
  this.emitUpdate();
},


  
    updatefacturacionConsultorPorcentaje(item) {
      item.fechaImputacionPorcentaje = new Date();
      this.emitUpdate();
    },
    onHorasEstimadasChange() {
      this.updateHorasTotalesEstimadas();
      this.emitUpdate();
    },

    emitUpdate() {
      this.$emit("update-equipo", [...this.equipoLocal]);
    },

    // UI helpers
    showMsgBoxConfirm(msg, vari, title) {
      this.$bvModal.msgBoxOk(msg, {
        title,
        size: "lg",
        buttonSize: "sm",
        okVariant: vari,
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
  },
  updated() {
    this.recalcular();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
    this.updateHorasTotalesEstimadas();
  },
};
</script>


<style>
.tabla-consultores {
  border-collapse: collapse;
  width: 70%;
}
.tabla-consultores th,
.tabla-consultores td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}
.tabla-consultores th {
  background-color: #f2f2f2;
}
.table-container {
  display: flex;
  justify-content: center;
}
</style>
